/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 方法导出文件
	 */
	
	var exports = __webpack_require__(1);
	
	exports(
			"browser",
			"woxinSupport" ,
			"fdapi"
	);
	


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 方法导出工具
	 */
	
	var window = __webpack_require__(2);
	
	var exportNamespaces = "tellhowdm";
	
	module.exports = function() {
		if (!window[exportNamespaces]) {
			window[exportNamespaces] = {};
		}
		var doExport = function(funName) {
			window[exportNamespaces][funName] = __webpack_require__(3)("./" + funName + ".js");
		};
		for (var i=0; i<arguments.length; i++) {
			var funName = arguments[i];
			doExport(funName);
			
		}
		
	}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	
	/**
	 * 提供代理的浏览器window对象
	 * 
	 * 应用中获取的所有的window对象都应从这里获取，便于进行AOP扩展
	 * 
	 */
	module.exports = window;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./browser.js": 4,
		"./fdapi.js": 5,
		"./fdapi/commons/commons.js": 15,
		"./fdapi/commons/config.js": 7,
		"./fdapi/commons/helper.js": 16,
		"./fdapi/orderCenter.js": 17,
		"./fdapi/product.js": 6,
		"./woxinSupport.js": 9
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	
	/**
	 * 浏览器类型判断
	 * 
	 * brower.versions.ios
	 * 
	 */
	module.exports = {
		versions:function(){
			var u = navigator.userAgent;
			return {
				mobile: !!u.match(/AppleWebKit.*Mobile.*/)||!!u.match(/AppleWebKit/), //是否为移动终端
				ios: !!u.match(/(i[^;]+\;(U;)? CPU.+Mac OS X)/), //ios终端
				android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
	       };
		}(),
		language:(navigator.browserLanguage || navigator.language).toLowerCase()
			
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by shiying on 2017/4/29.
	 */
	
	module.exports = {
	    product : __webpack_require__(6),
	    orderCenter : __webpack_require__(17)
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	
	var window = __webpack_require__(2)
	var config = __webpack_require__(7)
	var helper = __webpack_require__(16)
	var extend = __webpack_require__(8)
	
	
	// 导入默认配置
	config.defaultConfigs.urls["product"] = {
	    productInfo : 'product/productInfo.json'
	};
	
	
	var productInfo = function(parmars, reload) {
	    var defaultParmar = {
	        productId : undefined
	    };
	    return helper.reqHelper(
	        "product", "productInfo",
	        extend({}, defaultParmar, parmars), reload,
	        function(obj) {
	            return obj && obj.productInfo && obj.productInfo.id && obj.productInfo.id.length > 0
	        }).then(function(json) {
	            return json.productInfo;
	        });
	};
	
	
	
	module.exports = {
	    productInfo : productInfo
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by
	 */
	
	
	var extend = __webpack_require__(8)
	var window = __webpack_require__(2)
	
	var woxinSupport = __webpack_require__(9)
	var commons = __webpack_require__(15)
	
	/**
	 * 默认配置
	 * @type {{urls: {base: string, product: {productInfo: string}}}}
	 */
	var defaultConfigs = {
	    urls : {
	        base : '/data/'
	    }
	
	};
	
	var sysConfigKey = "JXSM_FDAPI";
	
	/**
	 * 获取环境配置
	 * @returns {*}
	 */
	var getEvnConfig = function() {
	    if (window[sysConfigKey]) {
	        return window[sysConfigKey];
	    } else {
	        return {};
	    }
	}
	
	/**
	 * 获取最终配置
	 */
	var getConfigRelease = function() {
	    return extend(true, defaultConfigs, getEvnConfig());
	}
	
	/**
	 * 获取地址配置
	 * @param group
	 * @param name
	 * @returns {string}
	 */
	var getConfigUrl = function(group, name) {
	    var conf = getConfigRelease()
	    var url = conf.urls.base + conf.urls[group][name];
	    // 增加我信登陆支持
	    return new Promise(function(resolve, reject) {
	        woxinSupport.loginInfo(function(mobile, token) {
	            if (mobile && token) {
	                // 优先使用phone+token
	                url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "mobile=" + mobile + "&token=" + token;
	                resolve(url);
	            } else {
	                // 尝试使用terminalId
	                var terminalId = commons.getUrlParmar("terminalId");
	                var mobile = commons.getUrlParmar("mobile");
	                var token = commons.getUrlParmar("token");
	                if (terminalId && terminalId.length > 0) {
	                    url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "terminalId=" + terminalId;
	                    resolve(url);
	                } else if (mobile && mobile.length > 0) {
	                    url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "mobile=" + mobile + "&token=" + token;
	                    resolve(url);
	                } else {
	                    resolve(url);
	                }
	            }
	        });
	    });
	};
	
	module.exports = {
	    defaultConfigs : defaultConfigs,
	    getConfigUrl : getConfigUrl
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	// var debug = require("../support/debug.js");
	var woxin = __webpack_require__(10);
	var window = __webpack_require__(2);
	var escape = __webpack_require__(11);
	var logger = __webpack_require__(12);
	var debug = __webpack_require__(13);
	var browser = __webpack_require__(4);
	
	
	var debug_userPhone = "woxinSupport_userPhone";
	var debug_userLevel = "woxinSupport_userLevel";
	var debug_cityCode = "woxinSupport_cityCode";
	var debug_share = "woxinSupport_share";
	var debug_pay = "woxinSupport_pay";
	var debug_local = "woxinSupport_userLocal";
	var debug_appInfo = "woxinSupport_appInfo";
	
	
	
	// 获取用户信息的IOS支持
	//		> 相关方法必须在top页面引入tellhowdm.js
	//		> 页面ready后，延迟一段时间再调用相关方法
	window.top._jxsm_ios_info_cache = {
			phoneNO : undefined,
			cityCode : undefined,
			userName : undefined,
			token : undefined,
			inLevel : undefined,
			version : -1
	};
	if (browser.versions.ios) {
		window.openhtmlgetStars = function(phoneNO,cityCode,userName,token,inLevel) {
			window.top._jxsm_ios_info_cache.phoneNO = phoneNO;
			window.top._jxsm_ios_info_cache.cityCode = cityCode;
			window.top._jxsm_ios_info_cache.userName = userName;
			window.top._jxsm_ios_info_cache.token = token;
			window.top._jxsm_ios_info_cache.inLevel = inLevel;
		}
		window.getVersionCode = function(version) {
			window.top._jxsm_ios_info_cache.version = version;
		}
	}
	
	
	/**
		url：分享的链接，如无则传空
	    titel：链接名称，如无则传空
	    text：描述（分享时的内容,如为短信则传要发送的内容）
	    logoUrl：微信上看到的小图片（最好不要超过10K，否则有可能分享不了），短信传空
	    mobile：短信分享对方号码，如无则传空
	 */
	var share = function(url, title, text, logoUrl, mobile) {
		if (debug(debug_share)) {
			alert("woxin分享接口调用\n\nurl : "+url+"\ntitle : "+title+"\ntext : "+text+"\nlogoUrl : "+logoUrl+"\nmobile : "+mobile+"");
			return;
		}
		if (browser.versions.android) {
			woxin.share(url, title, text, logoUrl, mobile);
			
		} else if (browser.versions.ios) {
			var shareurl = "shangmeng://woxin.com/woxinshare1234567890"+ url + "1234567890" + escape.EncodeUtf8(title) + "1234567890" 
				+ escape.EncodeUtf8(text) + "1234567890" + logoUrl + "1234567890" + mobile;
			document.location = shareurl;
			
		} else {
			logger("未知浏览器类型，不能调用woxin分享接口");
			
		}
	};
	
	
	/**
	 * 获取编译版本
	 */
	var buildVersion = function(callback) {
		if (browser.versions.android) {
			if (!woxin.getVersonCode) {
				callback(-1);	// < 130
			} else {
				callback(woxin.getVersonCode());
			}
			
		} else if (browser.versions.ios) {
			window.setTimeout(function() {
				callback(window.top._jxsm_ios_info_cache.version);
			}, 100);
		}
	};
	
	
	/**
	 * 是否支持支付宝
	 */
	var isSupportAlipay = function(callback) {
		buildVersion(function(version) {
			if (browser.versions.android) {
				callback(version >= 130)
				
			} else if (browser.versions.ios) {
				callback(version >= 34)
				
			}
		});
	};
	
	
	/**
	 * 调用支付
	 * @sessionId 
	 * @callback 回调方法
	 * @paytype alipay/hebao
	 * 
	 * 
	 * callback(code, errmsg)
	 * 
	 * code : 	支付宝9000支付成功，6001用户取消
	 * 			和包 0：成功 1：取消 2：失败
	 * 
	 */
	var pay = function(sessionId, callback, paytype) {
		// 兼容旧版本接口
		if (!paytype || ["hebao", "alipay"].indexOf(paytype) == -1) {
			paytype = "hebao";
		}
		// 调用支付接口
		if (debug(debug_pay)) {
			alert("woxin支付接口调用\n\nsessionId : "+sessionId+" \n\npaytype : " + paytype + " \n\n");
			if ('hebao' == paytype) {
				window.top.successinfo();
			} else if ("alipay" == paytype) {
				window.top.alipayResult();
			}
			return;
		}
		if (browser.versions.android) {
			if ('hebao' == paytype) {
				// 注册回调通知
				window.top.successinfo = callback;
				//
	            woxin.loadPayPluginNoWX(sessionId);
				/*buildVersion(function(version) {
					if (version >= 140) {
						// 新版本支付，跳转到和包支付
						woxin.loadMocamOpenPay(sessionId);
						
					} else {
						// 旧版本支付，和包插件式唤起
						woxin.loadPayPluginNoWX(sessionId);
						
					}
				});*/
				
			} else if ("alipay" == paytype) {
				window.alipayResult = callback;
				window.top.alipayResult = callback;
				//
				woxin.callAliPay(sessionId);
				
			}
			
		} else if (browser.versions.ios) {
			if ('hebao' == paytype) {
				// 注册回调通知
				window.top.successinfo = callback;
				//
	            // 旧版本支付，和包插件式唤起
	            var payInUrl = "shangmeng://callPay1234567890" + sessionId;
	            document.location = payInUrl;
	            /*
				buildVersion(function(version) {
					if (version >= 62) {
						// 新版本支付，跳转到和包支付
						window.woxincallhebaoapppay(sessionId);
						
					} else {
						// 旧版本支付，和包插件式唤起
						var payInUrl = "shangmeng://callPay1234567890" + sessionId;
						document.location = payInUrl;
						
					}
				});
				*/
			} else if ("alipay" == paytype) {
				window.top.alipayresult = callback;
				//
				var payInUrl = "callalipay:" + sessionId;
				document.location = payInUrl;
				
			}
			
		} else {
			logger("未知浏览器类型，不能调用woxin支付接口");
			
		}
		
	};
	
	
	/**
	 * 获取用户手机号码（明文）
	 */
	var userPhone = function() {
		if (debug(debug_userPhone)) {
			return debug(debug_userPhone);
		}
		if (browser.versions.android) {
			return woxin.getCellPhone();
			
		} else if (browser.versions.ios) {
			return window.top._jxsm_ios_info_cache.phoneNO;
			
		} else {
			logger("未知浏览器类型，不能调用woxin手机号码接口");
			return undefined;
			
		}
		
	};
	
	
	/**
	 * 获取登陆信息
	 */
	var loginInfo = function(callback) {
		if (browser.versions.android) {
			if (callback && typeof(callback) == 'function') {
				callback({
					phone : woxin.getCellPhone(),
					token : encodeURIComponent(woxin.getAccessToken())
				});
			}
			
		} else if (browser.versions.ios) {
			window.setTimeout(function() {
				if (callback && typeof(callback) == 'function') {
					callback({
						phone : window.top._jxsm_ios_info_cache.phoneNO,
						token : encodeURIComponent(window.top._jxsm_ios_info_cache.token)
					});
				}
			}, 300);
			
		} else {
			logger("未知浏览器类型，不能调用woxin登陆信息接口");
			return undefined;
			
		}
	};
	
	
	/**
	 * 获取用户星级
	 */
	var userLevel = function() {
		if (debug(debug_userLevel)) {
			return debug(debug_userLevel);
		}
		if (browser.versions.android) {
			return woxin.getUserStar();
			
		} else if (browser.versions.ios) {
			return window.top._jxsm_ios_info_cache.inLevel;
			
		} else {
			logger("未知浏览器类型，不能调用woxin用户星级接口");
			
		}
		
	};
	
	
	var cityCode = function() {
		var treatment = function (code) {
			if (code && code.length < 4) {
				return "0" + code;
			}
		};
		if (debug(debug_cityCode)) {
			return treatment(debug(debug_cityCode));
		}
		if (browser.versions.android) {
			return treatment(woxin.getCityCode());
			
		} else if (browser.versions.ios) {
			return treatment(window.top._jxsm_ios_info_cache.cityCode);
			
		} else {
			logger("未知浏览器类型，不能调用woxin用户地市接口");
			
		}
	};
	
	
	/**
	 * 用户地理位置
	 */
	var userLocal = function() {
		if (debug(debug_local)) {
			return debug(debug_local);
		}
		if (browser.versions.android) {
			return {
				x : woxin.getLocationX(),
				y : woxin.getLocationY()
			};
		} else if (browser.versions.ios) {
			return {
				x : woxinlongitude,
				y : woxinlatitude
			};
		} else {
			logger("未知浏览器类型，不能调用woxin用户GPS接口");
		}
	};
	
	
	/**
	 * 用户信息
	 */
	var appInfo = function() {
		if (debug(debug_appInfo)) {
			return debug(debug_appInfo);
		}
		var infoStr = woxin.getAppInfo();
		if (!infoStr) {
			return {};
		} else {
			// 355464060328472,3.0.4,122,WIFI
			var groups = /([^,]*),([^,]*),([^,]*),([^,]*)/ig.exec(infoStr);
			if (!groups) {
				return {};
			}
			return {
				imei : groups[1],
				version : groups[2],
				versionCode : groups[3],
				networkType : groups[4]
			}
		}
	};
	
	
	
	
	/**
	 * 选择app通讯录
	 * @num 选择数量
	 * @callback 回调通知
	 * 		resultCode 状态码，0成功
	 * 		resultMsg 错误消息
	 * 		list 选择列表
	 * 		orimsg 原始对象
	 */
	var selectPhone = function(num, callback) {
		// 注册回调通知
		var result = function(resultCode, resultMsg, tel, name) {
			// 成功： resultCode == "0"
			var list = [];
			var telArray = tel.split("|");
			for (var i=0; i<telArray.length; i++) {
				list.push({
					name : name.split("|")[i],
					tel : telArray[i]
				})
			}
			if (callback && typeof(callback) == 'function') {
				callback(resultCode, resultMsg, list, {
					resultCode : resultCode,
					resultMsg : resultMsg,
					tel : tel,
					name : name
				});
			}
		};
		window.top.getmultiphonedirectoryresult = result;
		window.top.getphonedirectoryresult1 = result;
		// 调用
		if (browser.versions.android) {
			woxin.getMutiphonedirectory(num)
			
		} else if (browser.versions.ios) {
			var spInUrl = "shangmeng://getMutiphonedirectory1234567890" + num;
			document.location = spInUrl;
			
		} else {
			logger("未知浏览器类型，不能调用woxin通讯录选择接口");
			
		}
		
	};
	
	
	/**
	 * 选择系统通讯录
	 * @callback 回调通知
	 * 		resultCode 状态码，0成功
	 * 		resultMsg 错误消息
	 * 		list 选择列表
	 * 		orimsg 原始对象
	 */
	var selectPhoneBySys = function(callback) {
		// 注册IOS回调通知
		var resultIOS = function(name, tel) {
			if (callback && typeof(callback) == 'function') {
				callback("0", "默认", tel,name);
			}
		};
		// 注册Android回调通知
		var resultAndroid = function(errcode, errmsg, name, phone) {
			// 成功： resultCode == "0"
			if (callback && typeof(callback) == 'function') {
				callback(errcode, errmsg, phone.replace(/\s+/g,""),name);
			}
		};
		window.top.systemContactResult = resultIOS;
		window.top.getphonedirectoryresult = resultAndroid;
		// 调用
		if (browser.versions.android) {
			window.woxin.selectSystemContact();
		} else if (browser.versions.ios) {
			woxinIosMethodWithArgs('chooseSystemContactPeople');
		} else {
			logger("未知浏览器类型，不调用通讯录选择接口");
		}
		
	};
	
	/**
	 * 是否支持选择系统通讯录
	 */
	var isSupportSelectPhoneBySys = function(callback) {
		buildVersion(function(version) {
			if (browser.versions.android) {
				callback(version >= 139)
				
			} else if (browser.versions.ios) {
				callback(version >= 62)
				
			}
		});
	};
	/**
	 * 设置title
	 */
	var setTitle = function(title) {
		if (browser.versions.android) {
			window.woxin.wxSetTitle(title);
		} else if (browser.versions.ios) {
			wxSetTitle(title);
		}
	};
	try{
		if (browser.versions.android||browser.versions.ios) {
			setTitle(document.title);
		}
	}catch (e) {
		console.log("init[setTitle]exception");
	}
	/**
	 * 是否支持IM
	 */
	var isSupportWxChat = function(callback) {
	    buildVersion(function(version) {
	        if (browser.versions.android) {
	            callback(version >= 140)
	
	        } else if (browser.versions.ios) {
	            callback(version > 62)
	        }
	    });
	};
	var wxChat = function (phone,callback) {
	    if (browser.versions.android) {
	        window.woxin.wxChatWithFriend('sm',phone);
	    } else if (browser.versions.ios) {
	        window.wxChatWithFriend('sm',phone);
	    } else {
	        logger("未知浏览器类型，不调用chat接口");
	    }
	}
	/**
	 * 调用JS方法  控制顶部导航栏
	 * type :1 为文字按钮    2为图片按钮     如果为2   第二个参数为图片路径
	 */
	var setRightButton = function(type,text) {
	    if (browser.versions.android) {
	        window.woxin.smsetrightbutton(type,text);
	    } else if (browser.versions.ios) {
	        window.smsetrightbutton(type,text);
	    }
	};
	try{
	    if (browser.versions.android||browser.versions.ios) {
	        setRightButton(1,"");
	    }
	}catch (e) {
	    console.log("init[setRightButton]exception");
	}
	
	/**
	 * 调用JS方法  控制顶部导航栏
	 * type :1 为文字按钮    2为图片按钮     如果为2   第二个参数为图片路径
	 */
	var getContactJsonString = function(type,text) {
	    if (browser.versions.android) {
	        window.woxin.getContactJsonStringMethod();
	    } else if (browser.versions.ios) {
	        window.smsetrightbutton(type,text);
	    }
	};
	/**
	 * 调用JS方法  获取通讯录全量数据，以json形式返回
	 */
	var getContactJsonString = function(callback) {
	
	    // 注册回调通知
	    var result = function(jsonstring) {
	        if (callback && typeof(callback) == 'function') {
	            if (browser.versions.android) {
	                callback(JSON.stringify(jsonstring));
	            } else if (browser.versions.ios) {
	                callback(jsonstring);
	            }
	        }
	    };
	
	    window.top.getAllContactString = result;
	    // 调用
	    if (browser.versions.android) {
	        window.woxin.getContactJsonStringMethod();
	    } else if (browser.versions.ios) {
	        requestContactJsonString();
	    } else {
	        logger("未知浏览器类型");
	    }
	
	};
	/**
	 * 我信js支持方法
	 */
	module.exports = {
			share : share,
			pay : pay,
			userPhone : userPhone,
			userLevel : userLevel,
			userLocal : userLocal,
			cityCode : cityCode,
			appInfo : appInfo,
			selectPhone : selectPhone,
			selectPhoneBySys : selectPhoneBySys,
			buildVersion : buildVersion,
			isSupportAlipay : isSupportAlipay,
			loginInfo : loginInfo,
			isSupportSelectPhoneBySys : isSupportSelectPhoneBySys,
			setTitle : setTitle,
	    	isSupportWxChat : isSupportWxChat,
	    	wxChat : wxChat,
	    	setRightButton : setRightButton,
	    	getContactJsonString : getContactJsonString
	}
	
	
	
	
	
	
	
	
	
	


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 和我信JSSDK支持方法
	 * 
	 */
	var window = __webpack_require__(2);
	
	if (window.woxin) {
		module.exports = window.woxin;
		
	} else {
		module.exports = {
				getCellPhone : function() {return undefined;}
				, getAccessToken : function() {return undefined;}
				, share : function() {return undefined;}
				, loadPayPlugin : function() {return undefined;}
				, getUserStar : function() {return undefined;}
				, getCityCode : function() {return undefined;}
				, getCellPhone : function() {return undefined;} 
				, getLocationX : function() {return undefined;}
				, getLocationY : function() {return undefined;}
				, getAppInfo : function() {return undefined;}
				, getMutiphonedirectory : function(num) {return undefined;}
				, callAliPay : function(sessionString) {return undefined;}
				, selectSystemContact :	function() {return undefined;}
				, wxSetTitle : function(title) {return undefined;}
				, wxChatWithFriend : function () {return undefined}
	        	, smsetrightbutton : function () {return undefined;}
	
		};
		
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	
		
		
	// 字符串转换utf-8  
	var EncodeUtf8 = function (s1) {  
	    // escape函数用于对除英文字母外的字符进行编码。如“Visit W3School!”->"Visit%20W3School%21"  
	    var s = escape(s1);  
	    var sa = s.split("%");//sa[1]=u6211  
	    var retV ="";  
	    if(sa[0] != "") {  
	        retV = sa[0];  
	    }  
	    for(var i = 1; i < sa.length; i ++) {  
	        if(sa[i].substring(0,1) == "u") {  
	            retV += Hex2Utf8(Str2Hex(sa[i].substring(1,5)));  
	            if(sa[i].length>=6) {  
	                retV += sa[i].substring(5);  
	            }  
	        }  
	        else retV += "%" + sa[i];  
	    }  
	    return retV;  
	};
	
	
	var Str2Hex = function(s) {  
	    var c = "";  
	    var n;  
	    var ss = "0123456789ABCDEF";  
	    var digS = "";  
	    for(var i = 0; i < s.length; i++) {  
	        c = s.charAt(i);  
	        n = ss.indexOf(c);  
	        digS += Dec2Dig(eval(n));
	    }  
	    //return value;  
	    return digS;  
	};
	
	
	var Dec2Dig = function(n1) {  
	    var s = "";  
	    var n2 = 0;  
	    for(var i = 0; i < 4; i++) {  
	        n2 = Math.pow(2,3 - i);  
	        if(n1 >= n2) {  
	            s += '1';  
	            n1 = n1 - n2;  
	        } else {
	            s += '0';  
	        }
	    }  
	    return s;  
	      
	};
	
	
	var Dig2Dec = function(s) {  
	    var retV = 0;  
	    if(s.length == 4) {  
	        for(var i = 0; i < 4; i ++) {  
	            retV += eval(s.charAt(i)) * Math.pow(2, 3 - i);  
	        }  
	        return retV;  
	    }  
	    return -1;  
	};
	
	
	var Hex2Utf8 = function(s) {  
	    var retS = "";  
	    var tempS = "";  
	    var ss = "";  
	    if(s.length == 16) {  
	        tempS = "1110" + s.substring(0, 4);  
	        tempS += "10" +  s.substring(4, 10);  
	        tempS += "10" + s.substring(10,16);   
	        var sss = "0123456789ABCDEF";   
	        for(var i = 0; i < 3; i ++) {   
	            retS += "%";   
	            ss = tempS.substring(i * 8, (eval(i)+1)*8);
	            retS += sss.charAt(Dig2Dec(ss.substring(0,4)));   
	            retS += sss.charAt(Dig2Dec(ss.substring(4,8)));   
	        }   
	        return retS;   
	    }   
	    return "";   
	}
	
	
	/**
	 * 编码工具包，为客户端交互提供支持方法
	 */
	module.exports = {
			EncodeUtf8 : EncodeUtf8,
			Str2Hex : Str2Hex,
			Dec2Dig : Dec2Dig,
			Dig2Dec : Dig2Dec,
			Hex2Utf8 : Hex2Utf8
	}
	
	
	
	
	
	
	
	


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	
	/**
	 * 日志工具
	 */
	module.exports = function() {
		// arguments 接收不定参数
		if (console && console.log) {
			console.log(arguments);
			
		} else {
			
			
		}
		
		
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * app debug 的支持方法
	 * 
	 * 支持在浏览器上使用调试对象为业务提供调试支持服务
	 * 
	 * 
	 * 例如：
	 * 	
	 * 	浏览器提供对象
	 *  window.debug = {		// 具体采用何种名字，由conf.appDebugNameSpace指定
	 *  	debugProp1 : 'aaa'
	 *  }
	 *  
	 *  业务端调用
	 *  var debug = require("support/debug");
	 * 	if (debug("debugProp1") == 'aaa') {
	 * 		// debug code
	 * 		
	 * 	} else {
	 * 		// normal code
	 * 		
	 * 	}
	 * 
	 * 
	 */
	
	var window = __webpack_require__(2);
	var conf = __webpack_require__(14);
	
	module.exports = function(key, defaultValue) {
		// if debug object is undefined
		if (!window[conf.appDebugNameSpace]) {
			window[conf.appDebugNameSpace] = {};
		}
		// get debug properties
		var val = window[conf.appDebugNameSpace][key];
		if (val) {
			return val;
		} else {
			return defaultValue;
		}
	}
	
	
	
	
	
	
	


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	
	/**
	 * 全局配置对象
	 */
	module.exports = {
		
		// appDebug的命名空间
		appDebugNameSpace : "tellhowdm_debug"
			
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by
	 */
	
	var window = __webpack_require__(2)
	
	    // 获取URL参数
	var getUrlParmar = function(name) {
	        var re = new RegExp("[\\?\\&]"+name+"=([^\\?\\&]*)", "ig");
	        var r = "";
	        while (r = re.exec(window.location.href)) {
	            var val = r[1];
	            return val;
	        }
	    };
	
	
	module.exports = {
	    getUrlParmar : getUrlParmar
	}
	


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by
	 */
	
	var config = __webpack_require__(7)
	var window = __webpack_require__(2)
	var sessionStorage = window.sessionStorage;
	
	var cacheKeyBase = "TELLHOWDM_FDAPI_CACHE_"
	
	/**
	 * 请求辅助方法
	 *
	 * @param urlConfigGroup URL配置的分组
	 * @param urlConfigName URL配置的名称
	 * @param parmars 请求参数
	 * @param enforceReload 如果为true，强制重新加载
	 * @param funcCheckDataValid 检查数据有效性，返回true，表示数据有效，进行缓存
	 * @returns {*} 标准的Promise对象，通过then/cache方法获取回调结果
	 */
	var reqHelper = function(urlConfigGroup, urlConfigName, parmars, enforceReload, funcCheckDataValid) {
	    // 缓存key
	    var cacheKey = cacheKeyBase + "_" + urlConfigGroup + "_" + urlConfigName + "_" + JSON.stringify(parmars);
	    // 检查缓存
	    var cache = sessionStorage.getItem(cacheKey);
	    if (enforceReload != true && cache) {
	        return new Promise(function(resolve) {
	            resolve(JSON.parse(cache));
	        });
	    }
	    // 发出请求
	    return config.getConfigUrl(
	        urlConfigGroup, urlConfigName
	
	    ).then(function (url) {
	        // 增加参数
	        for (var k in parmars) {
	            url = url + (url.indexOf("?") < 0 ? "?" : "&") + k + "=" + parmars[k];
	        }
	        // 发出请求
	        return window.fetch(url)
	
	    }).then(function (response) {
	        return response.json()
	
	    }).then(function(json) {
	        // 缓存数据
	        if (funcCheckDataValid && typeof(funcCheckDataValid) == 'function' && funcCheckDataValid(json)) {
	            sessionStorage.setItem(cacheKey, JSON.stringify(json));
	        }
	        // 继续返回
	        return json;
	
	    })
	};
	
	module.exports = {
	    reqHelper : reqHelper
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by shiying on 2017/4/29.
	 */
	
	var config = __webpack_require__(7)
	var helper = __webpack_require__(16)
	var extend = __webpack_require__(8)
	
	// 导入默认配置
	config.defaultConfigs.urls["orderCenter"] = {
	    orderList : 'orderCenter/orderList.json'
	};
	
	
	var orderList = function(parmars, reload) {
	    var defaultParmar = {
	        channel : undefined,
	        closeStatus : undefined,
	        pageNo : 1,
	        pageSize : 20
	    };
	    return helper.reqHelper(
	        "orderCenter", "orderList",
	        extend({}, defaultParmar, parmars), reload,
	        function(obj) {
	            return obj && obj.FLAG == '0'
	        });
	};
	
	
	module.exports = {
	    orderList : orderList
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// tellhowdm.js